// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.claim-MoVkWe-container{width:100%;height:100%}`, "",{"version":3,"sources":["webpack://./src/features/waf-captcha/view.module.scss"],"names":[],"mappings":"AAAA,wBACE,UAAA,CACA,WAAA","sourcesContent":[".container {\n  width: 100%;\n  height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `claim-MoVkWe-container`
};
export default ___CSS_LOADER_EXPORT___;
